import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { useAppContext } from '../../../../../../../../AppModulesWrapper';
import { selectAnalyticsVariant } from '../../../../../../../selectors/analytics';

import {
  IUseDurationsAnalytics,
  ITrackShowDurationsExtra,
  ITrackClickDurationParams,
  ITrackClickDurationExtra,
} from '../types';

export const useDurationsAnalytics = (): IUseDurationsAnalytics => {
  const { analytics } = useAppContext();

  const vas = useSelector(selectAnalyticsVariant);

  const trackShowDurations = useCallback(() => {
    analytics.send<ITrackShowDurationsExtra>({
      action: 'select_period_auction_sopr',
      label: 'show_period',
      extra: {
        vas,
      },
    });
  }, [analytics, vas]);

  const trackClickDuration = useCallback(
    ({ duration, discount }: ITrackClickDurationParams) => {
      analytics.send<ITrackClickDurationExtra>({
        action: 'select_period_auction',
        label: duration === 1 ? 'select_daily' : `select_${duration}days`,
        extra: {
          period_auction: {
            discount,
          },
          vas,
        },
      });
    },
    [analytics, vas],
  );

  return { trackShowDurations, trackClickDuration };
};
